/*
 * @format
 */

import * as actionTypes from '../action-types';

export const initialState = {
  messages: [],
  unreadCount: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGOUT_COMPLETED:
      return initialState;

    case actionTypes.HALO_NOTIFICATION_MESSAGES_RECEIVED:
      return {
        ...state,
        messages: action.messages,
      };

    case actionTypes.HALO_NOTIFICATION_MESSAGES_UNREAD_COUNT_RECEIVED:
      return {
        ...state,
        unreadCount: action.count,
      };

    case actionTypes.HALO_NOTIFICATION_MESSAGE_MARK_READ: {
      const targetMessage = state.messages.find(
        m => m.id === action.messageId,
      );
      const shouldDecrement = targetMessage && !targetMessage.IsRead;

      const updatedMessages = state.messages.map(m => {
        if (m.id === action.messageId) {
          return {
            ...m,
            IsRead: true,
            ReadAt: new Date().toISOString(),
          };
        }
        return m;
      });

      return {
        ...state,
        messages: updatedMessages,
        unreadCount: shouldDecrement
          ? Math.max(0, state.unreadCount - 1)
          : state.unreadCount,
      };
    }

    case actionTypes.HALO_NOTIFICATION_MESSAGE_HIDE: {
      const targetMessage = state.messages.find(
        m => m.id === action.messageId,
      );
      if (!targetMessage) {
        return state;
      }
      const shouldDecrement = !targetMessage.IsRead;

      return {
        ...state,
        messages: state.messages.filter(m => m.id !== action.messageId),
        unreadCount: shouldDecrement
          ? Math.max(0, state.unreadCount - 1)
          : state.unreadCount,
      };
    }

    default:
      return state;
  }
};
